import Cookies from 'js-cookie'

const MarketTeamType = '1';
const B2CTeamType = '2';
const ThirdPartyTeamType = '3';
const BTOCTeamType = '4';
const CampusTeamType = '5';

export function getToken () {
  return Cookies.get('staffToken')
}

export function getTeamCode () {
  return Cookies.get('teamCode')
}

export function getTeamType () {
  return Cookies.get('teamType')
}

export function getAgentCode () {
  return Cookies.get('agentCode')
}

export function getAgentName () {
  return Cookies.get('agentName')
}

export function getAgentStatus () {
  return Cookies.get('agentStatus')
}

export function getTeamStatus () {
  return Cookies.get('teamStatus')
}

export function getTeamRole () {
  return Cookies.get('teamRole')
}

export function getLoginInfos () {
  return localStorage.getItem('loginInfos')
}

export function getTeamName () {
  return Cookies.get('teamName')
}

export function getConversionPath () {
  return Cookies.get('conversionPath')
}

export function removeTeamName () {
  return Cookies.remove('teamName')
}

export function removeLoginInfos () {
  return localStorage.removeItem('loginInfos')
}

export function removeToken () {
  return Cookies.remove('staffToken')
}

export function removeTeamCode () {
  return Cookies.remove('teamCode')
}

export function removeTeamType () {
  return Cookies.remove('teamType')
}

export function removeAgentCode () {
  return Cookies.remove('agentCode')
}

export function setToken (token) {
  return Cookies.set('staffToken', token)
}

export function getStaffToken () {
  return Cookies.get('staffToken')
}

export function getStaffUserId () {
  return Cookies.get('userIdCrm')
}

export const isMarket = () => getTeamType() === MarketTeamType || getTeamType() === BTOCTeamType;
export const isB2C = () => getTeamType() === B2CTeamType;
export const isThirdParty = () => getTeamType() === ThirdPartyTeamType;
export const isCampus = () => getTeamType() === CampusTeamType;
export const isB2COrCampus = () => isB2C() || isCampus();

export function strangeSettings () {
  const expiresTime = { expires: 9 }
  Cookies.set('staffToken', Cookies.get('staffToken') || '', expiresTime)
  Cookies.set('agentCode', Cookies.get('agentCode') || '', expiresTime)
  Cookies.set('agentName', Cookies.get('agentName') || '', expiresTime)
  Cookies.set('agentStatus', Cookies.get('agentStatus') || '', expiresTime)
  Cookies.set('teamCode', Cookies.get('teamCode') || '', expiresTime)
  Cookies.set('teamType', Cookies.get('teamType') || '', expiresTime)
  Cookies.set('teamRole', Cookies.get('teamRole') || '', expiresTime)
  Cookies.set('teamStatus', Cookies.get('teamStatus') || '', expiresTime)
  Cookies.set('teamName', Cookies.get('teamName') || '', expiresTime)
  Cookies.set('conversionPath', Cookies.get('conversionPath') || '', expiresTime)
}
